import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { GlobalToastService } from '@doc/api/server-bo';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'doc-global-toast',
  templateUrl: './global-toast.component.html',
  styleUrls: ['./global-toast.component.scss'],
  standalone: true,
  imports: [CommonModule, TranslateModule]
})
export class GlobalToastComponent {
  constructor(public toastService: GlobalToastService) { }
}
